export default function isDefaultPool(poolId) {
  return poolId === 'default';
}
